/* @flow */

import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import LazyLoad from 'react-lazyload';
import Link from '../Link';
import brokenDeveloperLogo from '../../../public/images/errors/broken-developer-logo.png';
import RatingMark from '../RatingMark2.0';
import { Info, Title } from '../Tile/styles';

import { plural } from '../../utils';
import {
	DescItemContainer,
	DescItemTitle,
	DescItemValue,
	DevDesc,
	DeveloperContainer,
	DevHeadContainer,
	DevLogo,
	DevLogoImage,
	PropertiesButton,
	PropertiesButtonContainer,
	RatingContainer,
	Separator,
} from './styled';

type TProps = {
	item: {
		id: number,
		slug: string,
		logo: string,
		name: string,
		ratingDeveloper: number,
		tileType: string,
		groundDate: string,
		building: number,
		built: string,
		delayAvg: number,
	},
};

const DeveloperCard = forwardRef(({ item }: TProps, ref) => {
	const thisRef = useRef(null);

	useImperativeHandle(
		ref,
		() => ({
			focus() {
				thisRef?.current?.focus();
			},
			scrollIntoView() {
				thisRef?.current?.scrollIntoView();
			},
		}),
		[],
	);

	return (
		<DeveloperContainer key={item.id} ref={thisRef}>
			<Link
				to={item.slug && `/zastroischiki/${item.slug}/`}
				style={{ display: 'flex', flexDirection: 'column', flex: '1' }}
			>
				<LazyLoad height="100%" offset={100} once>
					<DevHeadContainer>
						<DevLogo $type={item.tileType || 'normal'}>
							<DevLogoImage
								src={item?.logo || brokenDeveloperLogo}
								alt={item.name}
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = brokenDeveloperLogo;
								}}
							/>
						</DevLogo>
						{item.ratingDeveloper && (
							<RatingContainer>
								<RatingMark value={item.ratingDeveloper} type="small" />
							</RatingContainer>
						)}
					</DevHeadContainer>
				</LazyLoad>
				<Info $type={item.tileType || 'normal'}>
					<div>
						{item && <Title>{item.name}</Title>}
						{!!item.groundDate && <DescItemContainer>На рынке с {item.groundDate} года</DescItemContainer>}
					</div>
					<div>
						<Separator />
						<DevDesc>
							{!!item.building && (
								<DescItemContainer>
									<DescItemTitle>Строится</DescItemTitle>
									<DescItemValue>{item.building}</DescItemValue>
								</DescItemContainer>
							)}
							{!!item.built && (
								<DescItemContainer>
									<DescItemTitle>Сдано</DescItemTitle>
									<DescItemValue>{item.built}</DescItemValue>
								</DescItemContainer>
							)}

							<DescItemContainer>
								<DescItemTitle>Задержка сдачи</DescItemTitle>
								<DescItemValue>
									{/* eslint-disable-next-line no-nested-ternary */}
									{item?.delayAvg
										? `${item.delayAvg} ${plural(item.delayAvg, ['месяц', 'месяца', 'месяцев'])}`
										: item?.delayAvg === 0
										? `без задержек`
										: `нет данных`}
								</DescItemValue>
							</DescItemContainer>
						</DevDesc>
						<PropertiesButtonContainer>
							<PropertiesButton>Подробнее</PropertiesButton>
						</PropertiesButtonContainer>
					</div>
				</Info>
			</Link>
		</DeveloperContainer>
	);
});

export default DeveloperCard;
